// --- タブ切り替え ----
document.addEventListener('DOMContentLoaded', function() {

  if (document.querySelector('.js-tab-switch')) {
        
    document.addEventListener('click', switchTab, false);
    
    function switchTab(e) {
      if (e.target.classList.contains('js-tab-switch__trigger')) {
        
        const target = e.target;
        const wrapper = target.closest('.js-tab-switch');
        const index = target.dataset.tabId;
        wrapper.querySelectorAll('.js-tab-switch__trigger').forEach(btn => {
          if (target == btn) {
            if (!btn.classList.contains('is-current')) {
              btn.classList.add('is-current');
            }
  
          } else {
            if (btn.classList.contains('is-current')) {
              btn.classList.remove('is-current');
            }
          }
        });
        wrapper.querySelectorAll('.js-tab-switch__target').forEach(content => {
        if (content.dataset.tabId == index) {
          if (!content.classList.contains('is-current')) {
            content.classList.add('is-current');
          }
        } else {
          if (content.classList.contains('is-current')) {
            content.classList.remove('is-current');
          }
        }
  
      });            
      }
    }
  }


})

